import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { User } from '@univacity/shared/types';
import { AnalyticsUtil } from '@univacity/shared/util';
import { Analytics, AnalyticsInstance } from 'analytics';
import posthog from 'posthog-js';
import { Configuration } from '../config';
import { TRACKED_EVENTS, TRACKED_PAGES } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  analytics: AnalyticsInstance;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    config: Configuration
  ) {
    this.analytics = Analytics({
      app: 'univacity',
      plugins: [
        // postHog({
        //   token: config.posthog.key,
        //   enabled: true,
        //   options: {
        //     api_host: config.posthog.host,
        //     // debug: process.env['NODE_ENV'] === 'dev',
        //     // persistence: 'memory',
        //     // disable_cookie: true,
        //     // disable_session_recording: true,
        //   },
        // }),
      ],
    });
  }

  identify(user: User) {
    const groupId = user.organisation;
    const userProp = AnalyticsUtil.user(user);
    this.analytics.identify(user._id, userProp, { context: { groupId } });
    posthog.identify(user._id, userProp);
    if (groupId)
      posthog.group('organisation', groupId, {
        organisationType: user.organisationType,
      });
    // Sentry.setUser(userProp);
  }

  track(event: TRACKED_EVENTS, meta: Record<string, any>) {
    this.analytics.track(event, meta);
    posthog.capture(event, meta);
  }

  page(
    title: TRACKED_PAGES,
    meta: Record<string, string | number | boolean> = {}
  ) {
    this.analytics.page({
      title,
      ...meta,
      ...this.route.snapshot.queryParams,
    });
    posthog.capture('$pageview', {
      title,
      ...meta,
      ...this.route.snapshot.queryParams,
    });
    posthog.capture('$set', { $pathname: this.router.url });
  }

  reset() {
    this.analytics.reset();
    posthog.reset();
    // Sentry.setUser(null);
  }
}
